import { useContext } from 'react'
import PropTypes from 'prop-types'
import { ProductContext } from '../ProductContext.jsx'

export default function ManageAccountsFilters({
  categoryOptions,
  onChange,
  onClose,
  selectedCategory,
}) {
  const { isMobile } = useContext(ProductContext)

  const onClassDropdownChange = (event) => {
    const value = event.target.value
    let _selected = [...selectedCategory]
    if (_selected?.includes(value)) {
      _selected = _selected?.filter((i) => i !== value)
    } else {
      _selected?.push(value)
    }
    onChange && onChange(_selected)
  }

  const onClickViewResults = () => {
    onClose && onClose()
  }

  const onClickClearFilters = () => {
    onChange && onChange([])
  }

  return (
    <>
      {isMobile ? (
        <div className="Accordion Accordion--ruled u-paddingHoriz2gu u-overflowY">
          <div className="u-marginBottom4gu u-flex u-flexJustifyBetween">
            <p className="u-textColorBrandDark u-textBold">
              Filters ({selectedCategory.length} Applied)
            </p>
            {/* eslint-disable-next-line jsx-a11y/no-redundant-roles -- CTINEXT-4711 */}
            <button
              type="button"
              onClick={() => onClose && onClose()}
              className="adel-material-symbols-14"
              // eslint-disable-next-line jsx-a11y/no-redundant-roles
              role="button"
              aria-label="Close"
            >
              <span aria-hidden="true">X</span>
              <span className="u-hiddenVisually">Close</span>
            </button>
          </div>
          <details className="Accordion-item u-paddingVert2gu">
            <summary className="Accordion-toggle u-paddingVert2gu">
              Asset Category
            </summary>
            <div>
              {Object.keys(categoryOptions)?.map((itm) => (
                <div key={itm} className="u-flex u-flexAlignItemsCenter">
                  <div className="Checkbox">
                    <input
                      type="checkbox"
                      id={`checkbox_${itm}`}
                      data-qa-automation={`checkbox_${itm}`}
                      className="Checkbox-button u-posRelative"
                      data-analytics={`filter-checkbox`}
                      checked={selectedCategory?.includes(itm)}
                      value={itm}
                      onChange={onClassDropdownChange}
                    />
                    <label
                      htmlFor={`checkbox_${itm}`}
                      className="Checkbox-label u-margin0"
                    >
                      <div className="u-textNoWrap">{itm}</div>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </details>
        </div>
      ) : (
        <div className="Grid Grid--withGutter u-paddingVert1gu u-paddingHoriz7gu">
          <div className="u-size6of12 u-sm-sizeFull">
            <h4 className="u-textSizeMsrp1 u-textBold MutualFunds-filterTitle u-textColorBrandDark">
              Asset Category
            </h4>
            <div>
              {Object.keys(categoryOptions)?.map((itm) => (
                <div key={itm} className="u-flex u-flexAlignItemsCenter">
                  <div className="Checkbox">
                    <input
                      type="checkbox"
                      id={`checkbox_${itm}`}
                      data-qa-automation={`checkbox_${itm}`}
                      className="Checkbox-button u-posRelative"
                      data-analytics={`filter-checkbox`}
                      checked={selectedCategory?.includes(itm)}
                      value={itm}
                      onChange={onClassDropdownChange}
                    />
                    <label
                      htmlFor={`checkbox_${itm}`}
                      className="Checkbox-label u-margin0"
                    >
                      <div className="u-textNoWrap">{itm}</div>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      <div className="InvestmentProductsFilterButtons u-sm-flex u-sm-paddingHoriz0 u-paddingVert4gu u-paddingHoriz7gu">
        <button
          className="Button Button--primary Button--small"
          data-tracking="view-results"
          onClick={onClickViewResults}
        >
          VIEW RESULTS
        </button>
        <button
          className="Button Button--tertiary Button--small u-marginLeft3gu"
          data-tracking="clear-filters"
          onClick={onClickClearFilters}
        >
          CLEAR FILTERS
        </button>
      </div>
    </>
  )
}
ManageAccountsFilters.propTypes = {
  selectedCategory: PropTypes.array,
  categoryOptions: PropTypes.object,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
}
